import './kp-documents-slider.less'
import type {Component} from 'typings/portaro.fe.types';
import type {RichDocument} from 'typings/portaro.be.types';
import KpCover from '../../../record/kp-cover/KpCover.svelte';

interface KpDocumentsSliderComponentBindings {
    documents: RichDocument[];
}

/**
 * @ngdoc component
 * @name kpDocumentSlider
 * @module portaro.components
 *
 * @param {RichDocument[]} documents documents stored in moving slider
 *
 * @description
 * Component for storing similar types of documents
 */
export default class KpDocumentsSliderComponent implements Component<KpDocumentsSliderComponentBindings> {
    public static componentName = 'kpDocumentsSlider';

    public templateUrl = require('./kp-documents-slider.tpl.ftl');
    public bindings = {
        documents: '<'
    } as const;
    public controller = KpDocumentsSliderComponentController;
}

class KpDocumentsSliderComponentController implements KpDocumentsSliderComponentBindings {
    public documents: RichDocument[];
    public kpCoverComponent = KpCover;
}
